'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _iBem = require('../../i-bem/i-bem.react');

var _bMenuMTypeCheckRadioRadiocheckMThemeNormalMWidthMaxMSizeXsSMNMViewClassicDefaultMToneDefaultDarkRedGrey = (require('./../../menu/menu.react.js'), require('./../../../desktop.blocks/menu/menu.react.js'), require('./../../menu/_type/menu_type_check.react.js'), require('./../../menu/_type/menu_type_radio.react.js'), require('./../../menu/_type/menu_type_radiocheck.react.js'), (require('./../../menu/_view/menu_view_default.react.js').default || require('./../../menu/_view/menu_view_default.react.js')).applyDecls());

var _bMenuMTypeCheckRadioRadiocheckMThemeNormalMWidthMaxMSizeXsSMNMViewClassicDefaultMToneDefaultDarkRedGrey2 = _interopRequireDefault(_bMenuMTypeCheckRadioRadiocheckMThemeNormalMWidthMaxMSizeXsSMNMViewClassicDefaultMToneDefaultDarkRedGrey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

exports.default = (0, _iBem.decl)({
    block: 'select2',
    elem: 'menu',
    willReceiveProps: function willReceiveProps(nextProps) {
        var drawingParams = nextProps.getDrawingParams();
        if (drawingParams) {
            var menuDomElem = (0, _reactDom.findDOMNode)(this._menu);
            var menuWidth = menuDomElem.getBoundingClientRect().width;
            var bestHeight = 0;

            drawingParams.forEach(function (params) {
                params.width >= menuWidth && params.height > bestHeight && (bestHeight = params.height);
            });

            this.setState({ maxHeight: Math.min(nextProps.maxHeight, bestHeight) });
        }
    },
    didMount: function didMount() {
        this.__base.apply(this, arguments);
        this.context.getMenu(this._menu);
    },
    render: function render() {
        var _this = this;

        var block = this.block,
            elem = this.elem,
            _props = this.props,
            itemIconHidden = _props.itemIconHidden,
            menuProps = _props.menuProps,
            items = _props.items,
            view = _props.view,
            tone = _props.tone;


        var mods = {
            'item-icon-hidden': this.__self.bool2string(itemIconHidden)
        };

        return _react2.default.createElement(
            _bMenuMTypeCheckRadioRadiocheckMThemeNormalMWidthMaxMSizeXsSMNMViewClassicDefaultMToneDefaultDarkRedGrey2.default,
            _extends({
                view: view,
                tone: tone,
                ref: function ref(m) {
                    return _this._menu = m;
                },
                mix: { block: block, elem: elem, mods: mods },
                width: 'max',
                style: { maxHeight: this.state.maxHeight },
                tabIndex: null
            }, menuProps),
            items
        );
    }
}, {
    contextTypes: {
        getMenu: _propTypes2.default.func
    }
});